import { render, staticRenderFns } from "./PSBankAccountForm.vue?vue&type=template&id=7f7fe35a&"
import script from "./PSBankAccountForm.vue?vue&type=script&lang=ts&"
export * from "./PSBankAccountForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports